// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const MainContainer = styled.div `
  .root-app_layout {
    width: 100%;
    position: relative;

    .root-app_loading-container {
      z-index: 9999;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: fixed;
    }

    .root-app_env-label-container {
      width: 100%;
      height: var(--env-label-height);
    }

    /*
     * Nada do layout aparece enquanto o loading de abertura cobre a tela: o
     * menu V1 (a barra preta) é o padrão até o manifesto dizer a versão da UI,
     * e piscava atrás do carregamento.
     */
    .root-app_content--loading {
      visibility: hidden;
    }

    .root-app_content {
      .root-app_menu {
        &.hidden {
          display: none;
        }
        &.menu-v1 {
          top: 0;
          position: fixed;
          width: var(--menu-v1-width);
          /*
           * O '#root-app_side_content' (palco) é 'position: relative' e vem
           * depois no DOM: sem z-index ele pinta por cima do menu, e o menu
           * expandido fica atrás do iframe — cortado, com o clique caindo no
           * MFE. Abaixo dos drawers (1110) e do loading (9999).
           */
          z-index: 1000;
        }
      }
    }
  }
`;
//# sourceMappingURL=style.js.map